import React from 'react'
import { Global } from '@emotion/react'

const GlobalStyles: React.FC = () => {
  return (
    <Global
      styles={`
        html,body,#root{
          height: 100%;
        }

        body{
          font-size: 14px;
          color: var(--chakra-colors-textPrimary);
        }

        .react-datepicker-popper {
          .react-datepicker__triangle {
            display: none;
          }
        }
      `}
    />
  )
}

export default GlobalStyles
